import { PropsWithChildren } from 'react'
import { Outlet, useLocation } from '@tanstack/react-router'
import { motion } from 'motion/react'

import { CardsGameBridge } from '~/boundedContext/cards/components/cards-game-bridge'
import { CardsAutofillBridge } from '~/boundedContext/list/components/cards-autofill-bridge'
import { FixIosKeyboardOverflow } from '~/components/fix-ios-keyboard-overflow'
import { RxDbProvider } from '~/providers/rx-db-provider'

import { BottomMenu, type BottomMenuProps } from './bottom-menu'

const AnimatedContainer = ({ children }: PropsWithChildren) => {
  // TODO: investigate. It causes previous page to unmount and remount before navigation
  // https://github.com/TanStack/router/issues/3110
  const { pathname } = useLocation()

  return (
    <div className="flex max-w-full grow overflow-hidden">
      <motion.main
        key={pathname}
        animate={{ opacity: 1, y: 0 }}
        className="mx-auto flex w-full max-w-4xl grow flex-col justify-between gap-4 px-3 pb-3 sm-landscape:pb-3 md:pb-4"
        initial={{ opacity: 0, y: 10 }}
      >
        {children}
      </motion.main>
    </div>
  )
}

export type MainLayoutProps = PropsWithChildren &
  Pick<BottomMenuProps, 'paths'> & {
    isRxDbMemoryMode?: boolean
  }

export const MainLayout = ({ paths, isRxDbMemoryMode, children }: MainLayoutProps) => (
  <RxDbProvider isMemoryMode={isRxDbMemoryMode}>
    <FixIosKeyboardOverflow />
    <CardsGameBridge />
    <CardsAutofillBridge />
    {children}
    <div className="pb-safe pl-safe flex flex-col-reverse justify-between sm-landscape:flex-row supports-[height:100dvh]:h-[100dvh]">
      <BottomMenu paths={paths} />
      <AnimatedContainer>
        <Outlet />
      </AnimatedContainer>
    </div>
  </RxDbProvider>
)
